<template>
    <div class="share" @touchmove.prevent>
        <!-- 顶部元素 -->
        <img src="http://cdn.shikehuyu.com/card/game-link.png?v=1.0.3" class="share__link">
        <img src="http://cdn.shikehuyu.com/card/game-click.png?v=1.0.1" class="share__click" @click="jump">
        <img src="http://cdn.shikehuyu.com/card/game-link-finger.png?v=1.0.0" class="share__link__finger wanderVer1">
        <img :src="musicIcon" class="share__music" @click="toggleMusic">
        <!-- 底部元素 -->
        <img src="http://cdn.shikehuyu.com/card/share-logo.png?v=1.0.2" class="share__logo">
        <!-- 图片 -->
        <div class="share__img">
            <img src="http://cdn.shikehuyu.com/card/share-example.png?v=1.0.2" class="share__img__img">
            <img :src="poster" class="share__img__save">
        </div>
        <img src="http://cdn.shikehuyu.com/card/share-text.png?v=1.0.1" class="share__text">
        <img src="http://cdn.shikehuyu.com/card/share-save.png?v=1.0.0" class="share__save">
        <img :src="poster" class="share__save__img">
        <img src="http://cdn.shikehuyu.com/card/share-home.png?v=1.0.0" class="share__home" @click="toHome">
        <!-- 画布 -->
        <div class="share__canvas">
            <img class="share__canvas__bg" src="http://cdn.shikehuyu.com/card/share-poster-bg.png?v=1.0.2">
            <div class="share__canvas__num" v-html="total"></div>
            <img class="share__canvas__qrcode" src="http://cdn.shikehuyu.com/card/share-qrcode.png?v=1.0.0">
            <img class="share__canvas__text" :src="canvasText">
        </div>
    </div>
</template>

<script>
import html2canvas from 'html2canvas';

export default {
    name: 'share',
    data() {
        const index = Math.floor(Math.random() * 5);
        return {
            musicOn: this.$bus.musicOn,
            total: this.$bus.total,
            poster: null,
            canvasTextIndex: index
        };
    },
    computed: {
        musicIcon() {
            return `http://cdn.shikehuyu.com/card/icon-music-${this.musicOn ? 'on' : 'off'}.png?v=1.0.0`;
        },
        canvasText() {
            return `http://cdn.shikehuyu.com/card/share-poster-text-${this.canvasTextIndex}.png?v=1.0.0`;
        }
    },
    methods: {
        jump() {
            this.$bus.playMusic('click');
            this.$bus.jump();
        },
        toggleMusic() {
            this.$bus.toggleMusic();
            this.musicOn = this.$bus.musicOn;
            if (this.musicOn) {
                this.$bus.musicFadeIn('bg', 0, 0.5);
            } else {
                this.$bus.musicFadeOut('bg', 0.5, 0);
            }
            this.$bus.playMusic('click');
        },
        toHome() {
            this.$bus.playMusic('click');
            this.$router.replace('homepage');
        },
        createPoster() {
            window.scrollTo(0, 1);
            html2canvas(document.querySelector('.share__canvas'), {
                useCORS: true
            }).then((canvas) => {
                this.poster = canvas.toDataURL();
            });
        }
    },
    mounted() {
        this.$bus.$emit('showMessage', {
            message: '正在生成海报，请稍候...'
        });
        this.$nextTick(() => {
            this.createPoster();
        });
        window.share = this;
    }
};
</script>

<style lang="scss">
@import '../style/mixin.scss';
@import '../style/color.scss';
@import '../style/animation.scss';
.share {
    @include fullscreen;
    @include bg-cover;
    overflow: hidden;
    background-image: url('http://cdn.shikehuyu.com/card/share-bg.png?v=1.0.0');
    &__link {
        position: absolute;
        padding: 2vw 1vw;
        top: 0;
        left: 0;
        width: 14vw;
        &__finger {
            position: absolute;
            padding: 2vw 1vw;
            top: 2.5%;
            left: 2.5%;
            width: 8.5%;
            z-index: 1;
        }
    }
    &__click {
        position: absolute;
        padding: 8vw 1vw;
        top: 2%;
        left: -1%;
        width: 18%;
        z-index: 2;
    }
    &__music {
        position: absolute;
        padding: 2vw 1vw;
        top: 0;
        right: 0;
        width: 12vw;
    }
    &__logo {
        @include transform-center-x;
        bottom: 7vh;
        width: 80vw;
    }
    &__img {
        position: absolute;
        left: 50%;
        transform: translate(-50%, -105%);
        border: .06rem solid white;
        border-radius: .08rem;
        top: 52vh;
        width: 84vw;
        box-sizing: border-box;
        font-size: 0px;
        &__img {
            width: 100%;
        }
        &__save {
            @include fullfill;
            opacity: 0;
            z-index: 1;
        }
    }
    &__text {
        @include transform-center-x;
        top: 52vh;
        width: 50vw;
    }
    &__save {
        position: absolute;
        left: 50%;
        transform: translate(-50%, -160%);
        top: 74.6vh;
        width: 48.1vw;
    }
    &__save__img {
        position: absolute;
        left: 50%;
        transform: translate(-50%, -160%);
        top: 74.6vh;
        width: 48.1vw;
        height: 10.8vw;
        opacity: 0;
        z-index: 1;
    }
    &__home {
        @include transform-center-x;
        top: 74.6vh;
        width: 48.1vw;
    }
    &__canvas {
        position: absolute;
        top: 200%;
        left: 200%;
        width: 1184px;
        font-size: 0px;
        z-index: -1;
        &__bg {
            width: 100%;
        }
        &__num {
            position: absolute;
            top: 28.8%;
            left: 73.8%;
            transform: translate(-50%, -50%);
            color: rgb(255, 233, 86);
            font-weight: bold;
            font-size: 34px;
        }
        &__qrcode {
            position: absolute;
            left: 83.4%;
            bottom: 10.2%;
            height: 19.2%;
        }
        &__text {
            position: absolute;
            height: 18%;
            top: 4.8%;
            left: 37.71%;
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/components/share.vue